import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Departments() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>Departments</strong></p>
            </span><span className="bodyText">
              <div className="clear"></div>
            </span>
            <div id="apparel_right">
              <p><img src="/images/apparel.png" width="264" height="252" alt="Apparel" /></p>
              <p>&nbsp;</p>
            </div>
            <div id="apparel">
              <p className="welcome_heading">Our Departments:</p>
              <ul className="apparel">
                <li><Link to="/computer-science">Computer Science &amp; Engineering</Link></li>
                <li><Link to="/electronics-engineering">Electronics &amp; Communication Engineering</Link></li>
                <li><Link to="/mechanical-engineering">Mechanical Engineering</Link></li>
                <li><Link to="/apparel-design">Apparel Design &amp; Fabrication Technology</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Departments;
